import Attachment from '@/ecm/models/document/Attachment';

export default class Organization {
    constructor (dto) {
        this.id = -1;
        this.name = '';
        this.quota = 0;
        this.logo = new Attachment();
        this.registeredDevicesLimit = 0;
        this.twoFactorAuthenticationUsersLimit = 0;
        this.concurrentUsersLimit = 0;
        this.fullUsersLimit = 0;
        this.readonlyUsersLimit = 0;
        this.autorecognitionEnabled = false;

        if (dto) {
            this.id = dto.Id;
            this.name = dto.Name;
            this.quota = dto.QuotaGB;
            this.logo = new Attachment();
            this.logo.name = dto.PathLogo;
            this.registeredDevicesLimit = dto.RegisteredDevicesLimit;
            this.twoFactorAuthenticationUsersLimit = dto.TwoFactorAuthenticationUsersLimit;
            this.concurrentUsersLimit = dto.ConcurrentUsersLimit;
            this.fullUsersLimit = dto.FullUsersLimit;
            this.readonlyUsersLimit = dto.ReadonlyUsersLimit;
            this.autorecognitionEnabled = dto.AutorecognitionEnabled;
        }
    }

    toDto () {
        return {
            Id: this.id,
            Name: this.name,
            QuotaGB: this.quota,
            MaxUsr: this.maxUsers,
            FullUsersLimit: this.fullUsersLimit,
            ReadonlyUsersLimit: this.readonlyUsersLimit,
            ConcurrentUsersLimit: this.concurrentUsersLimit,
            RegisteredDevicesLimit: this.registeredDevicesLimit,
            TwoFactorAuthenticationUsersLimit: this.twoFactorAuthenticationUsersLimit,
            AutorecognitionEnabled: this.autorecognitionEnabled,
            Logo: this.logo,
        };
    }
}
